export default {
  video: {},
  profile: {},
  smartSearch: false,
  player: {},
  subtitleData: {
    upload: {
      subtitleListToBeUploaded: [],
      subtitleToBeUploaded: null,
    },
    fetching: [],
  },
  dubbingData: {
    upload: {
      dubbingListToBeUploaded: [],
      dubbingToBeUploaded: null,
    },
    fetching: [],
  },
  profile_id: null,
  internalError: false,
  aiWorkFlow: { isEnabled: false },
}
